import React from 'react'
import Modal from '../../../components/Modal'
import CurrencyInput from '../../../components/CurrencyInput'
import CustomSelect from '../../../components/CustomSelect/CustomSelect'
import DateRangeFilter from '../../../components/DateRangeFilter'
import { today } from '../utils/paymentHelpers'

export default function PaymentFormModal({
  showForm,
  resetForm,
  handleSubmit,
  saving,
  editingId,
  isAdmin,
  formData,
  setFormData,
  employees
}) {
  return (
    <Modal
      isOpen={showForm && isAdmin}
      onClose={resetForm}
      title={editingId ? 'Редактирование' : 'Ручная корректировка'}
      isBottomSheet={true}
    >
      <div className="payments-form-wrapper">
        <form className="payments-form" onSubmit={handleSubmit}>
          <div className="payments-form-row">
            <div className="input-group">
              <CustomSelect
                label="Сотрудник"
                value={formData.employee_id}
                onChange={(val) => setFormData({ ...formData, employee_id: val })}
                placeholder="Выберите сотрудника"
                options={employees.map(emp => ({
                  value: emp.id,
                  label: emp.is_legacy ? `${emp.name} (Архив)` : emp.name,
                }))}
              />
            </div>
            <div className="input-group">
              <CustomSelect
                label="Тип"
                value={formData.type}
                onChange={(val) => setFormData({ ...formData, type: val })}
                options={[
                  { value: 'bonus', label: 'Премия', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg> },
                  { value: 'fine', label: 'Штраф', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
                  { value: 'deduction_брак', label: 'Брак', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>, group: 'Удержания WB' },
                  { value: 'deduction_подмена', label: 'Подмена', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>, group: 'Удержания WB' },
                  { value: 'deduction_зависшие', label: 'Зависшие', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>, group: 'Удержания WB' },
                  { value: 'deduction_другое', label: 'Другое (WB)', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>, group: 'Удержания WB' },
                ]}
              />
            </div>
          </div>

          <div className="payments-form-row">
            <div className="input-group">
              <label htmlFor="pay-amount">Сумма (₽)</label>
              <CurrencyInput
                name="amount"
                required
                placeholder="0"
                value={formData.amount}
                onChange={(val) =>
                  setFormData({ ...formData, amount: val })
                }
              />
            </div>
            <div className="input-group">
              <label htmlFor="pay-comment">Комментарий</label>
              <input
                id="pay-comment"
                className="input"
                type="text"
                placeholder="Причина корректировки"
                value={formData.comment}
                onChange={(e) =>
                  setFormData({ ...formData, comment: e.target.value })
                }
              />
            </div>
          </div>

          {formData.type === 'fine' && (
            <div className="payments-form-row">
              <div className="input-group" style={{ gridColumn: 'span 2' }}>
                <CustomSelect
                  label="Причина штрафа"
                  value={formData.reason_code}
                  onChange={(val) => setFormData({ ...formData, reason_code: val })}
                  options={[
                    { value: '', label: 'Другое' },
                    { value: 'late', label: 'Опоздание' },
                    { value: 'no_show', label: 'Невыход' },
                    { value: 'misplaced', label: 'Неправильное размещение' },
                    { value: 'damage', label: 'Порча товара' },
                  ]}
                />
              </div>
            </div>
          )}

          <div className="payments-form-row">
            <div className="input-group">
              <label>Прикрепить фото/видео (обновлено)</label>
              <label 
                style={{ 
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '12px', border: '2px dashed var(--border-color, #ddd)', borderRadius: '8px',
                  cursor: 'pointer', color: 'var(--text-secondary)', fontSize: '14px',
                  background: 'var(--surface-hover, #f8f8f8)'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'4px'}}><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg> Выбрать из галереи
                <input
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFormData({ ...formData, file, preview_url: URL.createObjectURL(file) });
                    }
                  }}
                />
              </label>
              {(formData.preview_url || formData.saved_file_url) && (
                <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img 
                    src={formData.preview_url || formData.saved_file_url} 
                    alt="Предпросмотр" 
                    style={{ maxWidth: '100px', maxHeight: '100px', borderRadius: '4px', border: '1px solid var(--border-color)', objectFit: 'cover' }} 
                  />
                  <button 
                    type="button" 
                    className="btn btn-ghost btn-sm" 
                    style={{ color: 'var(--danger)', padding: '4px 8px' }} 
                    onClick={() => setFormData({ ...formData, file: null, preview_url: '', saved_file_url: '' })}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg> Удалить фото
                  </button>
                </div>
              )}
              <small style={{ color: 'var(--text-secondary)' }}>Необязательно. Можно прикрепить фото.</small>
            </div>

            <div className="input-group">
              <label htmlFor="pay-evidence-link">Ссылка на видео/доказательство</label>
              <input
                id="pay-evidence-link"
                className="input"
                type="url"
                placeholder="https://..."
                value={formData.evidence_url_link || ''}
                onChange={(e) => setFormData({ ...formData, evidence_url_link: e.target.value })}
              />
              <small style={{ color: 'var(--text-secondary)' }}>Необязательно. Ссылка на видео или яндекс.диск.</small>
            </div>
          </div>

          <div className="input-group" style={{ gridColumn: 'span 2' }}>
            <label>Период выплаты</label>
            <DateRangeFilter
              startDate={formData.period_start}
              endDate={formData.period_end}
              onApply={(start, end) => setFormData({ ...formData, period_start: start, period_end: end })}
              onReset={() => setFormData({ ...formData, period_start: today(), period_end: today() })}
            />
          </div>

          <div className="payments-form-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Сохранение...' : 'Сохранить'}
            </button>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={resetForm}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}
